import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faBars } from "@fortawesome/free-solid-svg-icons";
const TopNavbar = () => {
  return (
    <nav className="navbar justify-content-between fixed-top">
      <a
        href={process.env.REACT_APP_URL}
        className="navbar-brand main-title d-none d-md-block d-sm-none"
      >
        Transparencia en las industrias extractivas
      </a>
      <a
        href={process.env.REACT_APP_URL}
        className="navbar-brand main-title d-none d-block d-sm-none"
      >
        <FontAwesomeIcon icon={faHome} />
      </a>

      <div className="dropdown">
        <div className="navbar-brand main-title">
          <FontAwesomeIcon icon={faBars} />
        </div>
        <div className="menu dropdown-content" id="menu">
          <a
            href={
              process.env.REACT_APP_URL +
              "/deuda-corrupcion-como-herencia-municipio-abancay"
            }
          >
              Apurímac
          </a>
          <a
            href={
              process.env.REACT_APP_URL +
              "/cerro-verde-deficiencias-monitoreos-participativos"
            }
          >
              Arequipa
          </a>
          <a
            href={
              process.env.REACT_APP_URL +
              "/pobreza-corrupcion-provincias-mineras-cusco"
            }
          >
              Cusco
          </a>
          <a
            href={
              process.env.REACT_APP_URL +
              "/loreto-migajas-para-hijos-oro-negro"
            }
          >
              Loreto
          </a>
          <a
            href={
              process.env.REACT_APP_URL +
              "/santiago-pachas-pueblo-agoniza-sed"
            }
          >
              Moquegua
          </a>
          <a
            href={
              process.env.REACT_APP_URL +
              "/unp-invierte-apenas-5-canon-investigacion"
            }
          >
              Piura
          </a>
        </div>
      </div>
    </nav>
  );
};

export default TopNavbar;
